module.exports = "td{\r\n    border: 1px solid #ddd;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/planning/revisedpropertyregister/revisedpropertyregister-grid/revisedpropertyregister-grid.component.css
// module id = ./src/app/planning/revisedpropertyregister/revisedpropertyregister-grid/revisedpropertyregister-grid.component.css
// module chunks = main